import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import {useLogin} from "~/auth/hooks";
import {Box, Button, CircularProgress, Grid, Paper, TextField, Typography} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';


export type SignInFormProps = {
    onComplete: () => void
}


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 260,
        width: "100%",
    }
}))


export const SignInForm = (props: SignInFormProps) => {
    const classes = useStyles(props);
    const {onComplete} = props;
    const [login, {success: data, error, called, loading}] = useLogin();
    const [invalidData, setInvalidData] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const disabled = loading;
    const isValid = username.length && password.length;

    useEffect(() => {
        if (called && !loading && !error) {
            setInvalidData(!data);
        }
    }, [called, data, loading, error]);

    useEffect(() => {
        if (called && data && onComplete) {
            onComplete();
        }
    }, [data, called]);

    const handleChangeUsername = (e: ChangeEvent<HTMLInputElement>) => {
        setUsername(e.target.value);
        setInvalidData(false);
    }

    const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
        setInvalidData(false);
    }

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        login(username, password);
    }

    return (
        <form onSubmit={handleSubmit} className={classes.root} name="login" id="signInForm">
            <Box pb={2}>
                <TextField placeholder="Имя пользователя"
                           name="login"
                           fullWidth={true}
                           error={invalidData}
                           disabled={disabled}
                           value={username}
                           onChange={handleChangeUsername}
                />
            </Box>
            <Box pb={2}>
                <TextField placeholder="Пароль"
                           name="password"
                           type="password"
                           fullWidth={true}
                           error={invalidData}
                           disabled={disabled}
                           value={password}
                           onChange={handleChangePassword}
                />
            </Box>
            <Box pb={2}>
                <Button
                    type="submit"
                    color="primary"
                    fullWidth={true}
                    disabled={disabled || !isValid}
                >
                    {loading ? <CircularProgress size={24}/> : "Войти"}

                </Button>
            </Box>
            {invalidData && (
                <Typography color="error" variant="body2" align="center" id="signInForm.message">
                    Неверный логин или пароль.
                </Typography>
            )}
        </form>
    );
}